import "./Resources.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import Educationalhero from "./sections/Educationalhero";
import Newsletter from "./sections/Newsletter";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function ResourcesPage() {
  return <div>
      <Header />
      <Services />
      <Educationalhero />
      <Newsletter />
      <Inquiry />
      <Footer />
    </div>;
}